import { requestApi } from '../util/network'
// 获取视频
export const getRoomList =
    (params) =>
      requestApi(
        '/seller_minipro_live/get_room_list',
        'POST',
        {
          'page': params.page,
          'per_page': params.per_page
        },
        'seller'
      )
// 获取视频
export const getRoomInfo =
    (data) =>
      requestApi(
        '/seller_minipro_live/get_room_info',
        'POST',
        data,
        'seller'
      )
export const addRoom =
    (data) =>
      requestApi(
        '/seller_minipro_live/add_room',
        'POST',
        data,
        'seller'
      )
// 视频保存
export const importRoomGoods =
    (data) =>
      requestApi(
        '/seller_minipro_live/import_room_goods',
        'POST',
        data,
        'seller'
      )
// 删除视频
export const getGoodsList =
    (params) =>
      requestApi(
        '/seller_minipro_live/get_goods_list',
        'POST',
        {
          'page': params.page,
          'per_page': params.per_page
        },
        'seller'
      )
export const addGoods =
    (data) =>
      requestApi(
        '/seller_minipro_live/add_goods',
        'POST',
        data,
        'seller'
      )
// 上传封面
export const uploadMedia =
    (file) =>
      requestApi(
        '/seller_minipro_live/upload_media',
        'POST',
        file,
        'seller',
        true
      )
